import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IPortador } from '../model/portador.model';

@Injectable()
export class PortadorService extends EntityService<IPortador> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'portador',
        pluralBaseEntityEndPoint: 'portadores',
        urlBackend: configService.backendURL
      }
    );
  }

  public ajustarSaldo(
    portador_id: string,
    novo_saldo: number
  ): Observable<any> {
    const url = `${this.baseURL}/${portador_id}/ajuste_saldo`;
    const body = {
      valor: novo_saldo
    };

    return this.http.put(url, body, {
      headers: this.getHeader()
    });
  }
}
